export default __webpack_public_path__ + "static/6-dc991081d4b66d710932b193427678af.png";